import request from '@/utils/seftRequest';

// 查询的代理商BPAY自注册信息 /drm/ding/channel/qryFrBpayInfo
export function qryFrBpayInfo(params) {
  return request('/ding/channel/qryFrBpayInfo', { params });
}
